import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import { makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import ApplyPositions from "./applyPositions";
import { getAllocatedto, getJob, getCandidates, applyCandidateToJobByCSRecruiter } from './services';
import NotificationAlert from "../../components/notification";
import { viewedpageMixpanel } from '../../utils/mixpanel';
import { getAPI } from '../../api/api';
import { REACT_APP_COMMON } from '../../utils/common';


function Positions() {

  const navigate = useNavigate()
  const location = useLocation();
  const { jobId }: any = location.state || ''
  const {companyName}:any = location.state || ''
  
  const userloginId = localStorage.getItem("loginId");
  const menu = makeSideBarActive(CONSTANTS.crSideMenu, 1)
  const [selected, setSelected] = React.useState<number>(0);
  const [jobMetadata, setJobMetadata] = useState<{
    resources: number , experienceRange: number , title: string, contractDuration : string , startDate: number , minimumBudget: number , maximumBudget: number ,
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}]
  }>()
  const [resources, setResources] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [coreSkills, setCoreSkills] = useState<any>([])
  const [jobExperience, setJobExperience] = useState<any>({})
  const [filterValues, setFiltervalues] = useState<any>({})
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [rateInMail, setRateInMail] = useState(false)
  const [jobType, setJobType] = useState<any>({})
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()

  let BreadcrumsValues = ['Positions', jobMetadata?.title + ' - ' + companyName]

  useEffect(() => {
    
    getJobDetails(jobId)
    getAllocation();
    viewedpageMixpanel();

    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })
    
  }, [jobId])
  
  const getJobDetails = (jobId: any) => {
    getJob(jobId).then((response: any) => {
      if(response && response.status === 1){
        setJobMetadata(response.data[0].job_metadata)
        setRateInMail(response.data[0].showRateInEmail)
        let skills = response.data[0] && response.data[0].job_metadata && response.data[0].job_metadata.coreSkills.map((item: any) => {
          return item.skillName
        })
        setCoreSkills(skills)
        setJobExperience(response.data[0].job_metadata.experienceRange)
        setJobType(response.data[0].job_metadata.jobType)
        getAllCandidates(25, 1, '', skills, response.data[0].job_metadata.experienceRange, response.data[0].job_metadata.jobType)
        let experience = { from: response.data[0].job_metadata.experienceRange.min, to: response.data[0].job_metadata.experienceRange.max}
        setFiltervalues({core_skills: skills, experience: experience})
      }
    })
  }


  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === "success") {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const getPageChange = (pageSize: any, pageNumber: number) => {
    let body ={
      size: pageSize,
      from: pageNumber } 
      let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
      getAllCandidates(pageSize, page, '' , "",'','', '')
  }

  const getAllCandidates = (pageSize: number, pageNumber: number, searchValue: string, skills?: any, experienceRange?: any, job_type?: any, filters?: any) => { 

    let body ={}
    if (filters) {
      filters.resourcesToExcludeForJobIdCsr = jobId
      filters.inContract = false
      filters.behalf_of = {id: userloginId , name: ' '}
      filters.job_type = jobType
      body = {
         filters
      }
    }
    else {        
      body = {
        filters: {
          behalf_of: {id: userloginId , name: ' '},
          inContract: false,
          resourcesToExcludeForJobIdCsr: jobId,
          core_skills: skills,
          job_type: job_type,
          experience: jobExperience ? {
            'from': experienceRange && experienceRange.min,
            'to': experienceRange && experienceRange.max
          } : undefined
        }
      }
    }  
    getCandidates(pageSize, pageNumber, searchValue, body).then((resp: any) => {
      if( resp && resp.status === 1){
        setResources(resp.data) 
        setTotal(resp.count)
      }
    })
  }

  const searchChange = (e: string) => {
    
    getAllCandidates(25, 1, e, coreSkills, jobExperience, jobType)

  }

  const onSubmit = (data: any) => {
 
    let body = { 
      loginId : data.map((item: any) =>{ return (item.loginId)}) ,
      userLoginId : userloginId ,
      jobId: jobId
    }
    applyCandidateToJobByCSRecruiter(body).then((response: any) => {
      if(response && response.status === 1){
        displayNotification()
      }
    }) 
  }

  const displayNotification = () => {
    setMessage('Candidate Submitted Successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('../crposition-details',{ state: { jobId: jobId, positionName:jobMetadata?.title, companyName:companyName }})
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }
 
  const closeTag = (data: any) => {
    if (!data.experience) {
      setJobExperience(undefined)
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '','', data)
  }

  const applyFilter = (data: any) => {
    
    if (data.availability) {
      data.availability = data.availability.value
    }

    if (data.minimumBudget === '') {
      delete data.minimumBudget
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '','', data)
    
  }
  

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
        {message}
      </NotificationAlert> }
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues} navigateTo="" searchChange={''} />
        <ApplyPositions jobMetadata={jobMetadata} onSubmit={onSubmit} data={resources} total={total} pageSize={getPageChange} jobId={jobId} searchChange={searchChange} filtervalues={filterValues} closeTag={closeTag} allocatedTo={allocatedTo} applyFilter={applyFilter} rateInMail={rateInMail} skillsList={skillList} jobRolesList={jobRoleList} />        
      </div>
    </section>
  )
}

export default Positions